import { styled } from '@mui/material/styles'

export const StyledIcon = styled('img')(() => ({
  width: '13px'
}))
